import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import s from '../../IconV2.scss';

const Hanger32: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={
      chroma === 'dark'
        ? cn(s.svgDark32, `svg-icon--${icon}`)
        : cn(s.svgLight32, `svg-icon--${icon}`)
    }
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={chroma === 'dark' ? `${icon}-32-solid` : `${icon}-32`}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M19.0605775,11.3335784 C19.1480305,12.5453797 18.7759492,13.0415458 17.5928749,13.7039942 L17.113119,13.9650644 C17.0414263,14.0050454 16.9817063,14.1718642 16.9650934,14.5082725 L27.5574201,20.0724206 L27.7479381,20.206127 C28.4276197,20.7486024 28.672656,21.702419 28.3765562,22.5700237 C28.09576,23.4179616 27.3752131,23.9756794 26.5134861,23.9756794 L26.5134861,23.9756794 L5.98567495,23.9756794 C5.12564184,23.9756794 4.40484823,23.4198358 4.12421663,22.5793985 C3.80863465,21.6475931 4.10414144,20.6290472 4.89951609,20.0991422 L4.89951609,20.0991422 L4.9944361,20.042002 L15.462286,14.5459523 C15.4841162,13.7061167 15.6915504,13.1126615 16.2531306,12.7347811 L16.3910947,12.6502713 L16.989852,12.3247896 L17.2064776,12.1977246 C17.5775855,11.964926 17.5931299,11.8390836 17.5644319,11.4416156 C17.5249058,10.894306 16.9921966,10.4599717 16.3574152,10.5029534 C15.7672337,10.5429207 15.3261423,10.9791104 15.3019222,11.4798418 L15.3032105,11.5880084 L13.8070866,11.6960369 C13.7063403,10.3005051 14.8151745,9.10395902 16.2560724,9.00636056 C17.6944404,8.90898754 18.959951,9.94079743 19.0605775,11.3335784 Z M15.9665907,15.9766794 L5.74331055,21.3403153 L5.72239887,21.3535352 L5.6611071,21.4030998 C5.50905954,21.5509721 5.45068823,21.8199164 5.54596906,22.101267 C5.62916052,22.3504029 5.79161358,22.4756794 5.98567495,22.4756794 L5.98567495,22.4756794 L26.5134861,22.4756794 C26.7074908,22.4756794 26.8691198,22.3505753 26.9547702,22.0920297 C27.0600158,21.7836167 26.9728391,21.4837492 26.7990614,21.3676035 L26.7990614,21.3676035 L16.5445907,15.9826794 L15.9665907,15.9766794 Z"
        fill="#020303"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default Hanger32;
